var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlueCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 0a7.75 7.75 0 100 15.5 7.75 7.75 0 000-15.5zm0 14.5A6.75 6.75 0 011 7.75 6.75 6.75 0 017.75 1a6.75 6.75 0 016.75 6.75 6.75 6.75 0 01-6.75 6.75zm4.426-8.593l-5.64 5.595a.375.375 0 01-.53-.002L3.322 8.795a.375.375 0 01.002-.53L3.59 8a.375.375 0 01.53.002l2.156 2.173 5.108-5.066a.375.375 0 01.53.002l.264.266a.375.375 0 01-.002.53z",
    fill: "#3A50F3"
  })));
}

export default __webpack_public_path__ + "./fonts/blue-check-circle.8b1bdbcdb72c80664d7c3d56fdae82ed.svg";
export { SvgBlueCheckCircle as ReactComponent };